
import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";

import ListMessageOperatorSatiaScreen from "../ListMessageOperatorSatiaScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashSatiaScreen.results.item_count,
    allResult: state.reducerListMessageOperatorSatiaScreen.allResult,
    results: state.reducerListMessageOperatorSatiaScreen.results,
    NoInternetDialog: state.reducerListMessageOperatorSatiaScreen.NoInternetDialog,
    showLoading: state.reducerListMessageOperatorSatiaScreen.showLoading,
    lazyload_end: state.reducerListMessageOperatorSatiaScreen.lazyload_end,
    showRefresh: state.reducerListMessageOperatorSatiaScreen.showRefresh,
    failed: state.reducerListMessageOperatorSatiaScreen.failed,
    page: state.reducerListMessageOperatorSatiaScreen.page,
    empty: state.reducerListMessageOperatorSatiaScreen.empty,
    DataSplashScreen: state.reducerSplashSatiaScreen,
    resultsSet: state.reducerListMessageOperatorSatiaScreen.resultsSet,
    isLoadingSet: state.reducerListMessageOperatorSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListMessageOperatorSatiaScreen.NoInternetDialogSet,
    ListFilter: state.reducerListMessageOperatorSatiaScreen.ListFilter,
    id: state.reducerListMessageOperatorSatiaScreen.id,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id, func) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id, func) => {
    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetListMessageOperatorSatiaScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListMessageOperatorSatiaScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('token', store.getState().reducerSplashSatiaScreen.token == null ? '' : store.getState().reducerSplashSatiaScreen.token);
    formData.append('page', params.page);


    formData.append('unitTicket', params.unitTicket);
    formData.append('serviceTicket', params.serviceTicket);
    formData.append('priorityTicket', params.priorityTicket);
    formData.append('titleTicket', params.titleTicket);
    formData.append('messageTicket', params.messageTicket);

    formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);


    // formData.append('type', params.type);
    // formData.append('listFilter',JSON.stringify(params.listFilter) );
    // formData.append('trackingCode', params.trackingCode);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

  //  axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetListMessageOperatorSatiaScreen:


                    if (response.data.status) {


                        let data = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;
                        // dispatch(serviceActionListFilter(response.data.result.searchItems));

                        if (data == null) data = []
                        /*   let arr = store.getState().reducerListMessageOperatorSatiaScreen.results
                           if (page == 1) {
                               arr = data
                               global.list_menu_shahrdar=response.data.result.menu
                           } else {
                               if (arr.length > 0)
                               //    arr.push(data);
                                   arr = [...arr, ...data]
                               else
                                   arr = data
                           }*/

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee, response.data));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page, response.data))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee, response.data)));
                        }


                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMessageOperatorSatia +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMessageOperatorSatiaFilter + t, response.data.result.searchItems)

                    } else {
                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetListMessageOperatorSatiaScreen:
                    if (response.data.status) {
                        dispatch(serviceActionSuccessSet(response.data, id))

                        func ? func(1) : null;
                        //dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func))
                    }
                    else
                        dispatch(serviceActionErrorSet("error"))
                    //    alert(response.data.message)
                    break;
                default:
                    console.log("default")
            }
        }).catch((e) => {
        console.log("ahmad=> error", e)
        switch (type) {
            case typeExport.TypeGetListMessageOperatorSatiaScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListMessageOperatorSatiaScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id, func) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        } else {
            switch (type) {
                case typeExport.TypeGetListMessageOperatorSatiaScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListMessageOperatorSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListMessageOperatorSatiaScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListMessageOperatorSatiaScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListMessageOperatorSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page, allResult) => ({

    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    allResult: allResult,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page,allResult) => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page,
    allResult: allResult,

})
export const serviceActionEmpty = (page,allResult) => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page,
    allResult: allResult,

})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.ListMessageOperatorSatiaScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(ListMessageOperatorSatiaScreen);
